
import React, { useState, useEffect } from "react";
import {
  AppBar, Toolbar, Typography, Button, IconButton, InputBase, Box, TextField, Dialog,
  DialogTitle, DialogContent, DialogActions
} from "@mui/material"
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { format, isBefore, startOfDay } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";


import axiosClient from '../axios/api.js';


const QuotationDollor = () => {

  const [currencyExchangedialogopen, setCurrencyExchangedialogopen] = useState(false);
  const [currencyExchange, setCurrencyExchange] = useState("");
  const [dollarRate, setDollarRate] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [lastUpdatedDate, setLastUpdatedDate] = useState("");
    // Get current date in IST
    const getCurrentISTDate = () => {
      const now = new Date();
      const istDate = zonedTimeToUtc(now, "Asia/Kolkata");
      return format(istDate, "yyyy-MM-dd");
    };
  
    const dateIST = getCurrentISTDate();



  const fetchDollarRate = async () => {
    try {
      const response = await axiosClient.get("/api2/currencyExchange/latest");
          console.log("fetchDollarRatefetchDollarRatefetchDollarRatefetchDollarRatefetchDollarRatefetchDollarRatefetchDollarRate")
          console.log(response)
      if (response.data && response.data.dollar_rate) {
        setDollarRate(response.data.dollar_rate);
        setLastUpdatedDate(response.data.lastUpdatedDate);
        localStorage.setItem("dollarRate", response.data.dollar_rate);
        localStorage.setItem("lastUpdatedDate", response.data.lastUpdatedDate);

        // Show popup only if the last updated date is before today's date in IST
        const lastUpdated = new Date(response.data.lastUpdatedDate);
        const currentIST = zonedTimeToUtc(new Date(), "Asia/Kolkata");
        const startOfTodayIST = startOfDay(currentIST);

        if (isBefore(lastUpdated, startOfTodayIST)) {
          setCurrencyExchangedialogopen(true);
        }
      } else {
        setCurrencyExchangedialogopen(true);
      }
    } catch (error) {
      console.error("Error fetching dollar rate:", error);
      setCurrencyExchangedialogopen(true);
    }
  };

  useEffect(() => {
    fetchDollarRate();
  }, []);

  const handleCurrencyExchangeOpen = () => {
    setCurrencyExchange(dollarRate || ""); 
    setCurrencyExchangedialogopen(true);
  };
  
  const handleCurrencyExchangeClose = () => {
    setCurrencyExchange("");
    setCurrencyExchangedialogopen(false);
  };
  const handleCurrencyExchangeChange = (event) => setCurrencyExchange(event.target.value);
  // Update currency and close popup for all users
  const handleCurrencyExchange = async () => {
    if (!currencyExchange) {
      alert("Please enter a valid currency value");
      return;
    }
    try {
      setIsUpdating(true);
      const response = await axiosClient.put("/api2/currencyExchange/fullUpdate", { currencyExchange });

      if (response.status === 200) {
        setDollarRate(currencyExchange);
        setLastUpdatedDate(dateIST);
        localStorage.setItem("dollarRate", currencyExchange);
        localStorage.setItem("lastUpdatedDate", dateIST);

        alert(`Dollar value for Date: ${dateIST} is set to ₹${currencyExchange}`);

        handleCurrencyExchangeClose();
      }
    } catch (error) {
      console.error("Error updating currency exchange rate:", error);
    } finally {
      setIsUpdating(false);
    }
  };
    return(

        <>
        
        <Dialog 
                open={currencyExchangedialogopen} 
                onClose={handleCurrencyExchangeClose} 
                maxWidth="sm" 
                fullWidth
              >
                <DialogTitle align="center">Set Dollar Rate for Date: {dateIST} in ₹</DialogTitle>
                <DialogContent>
                  <Box sx={{ mt: 2 }}>
                    <TextField 
                      fullWidth 
                      value={currencyExchange} 
                      onChange={handleCurrencyExchangeChange} 
                      disabled={isUpdating}
                      type="number"
                      label="Dollar Rate"
                      variant="outlined"
                      inputProps={{ step: "0.01" }}
                    />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button 
                    onClick={handleCurrencyExchangeClose} 
                    color="primary" 
                    disabled={isUpdating}
                  >
                    Cancel
                  </Button>
                  <Button 
                    onClick={handleCurrencyExchange} 
                    color="primary" 
                    disabled={isUpdating}
                    variant="contained"
                  >
                    {isUpdating ? "Saving..." : "Save"}
                  </Button>
                </DialogActions>
              </Dialog>
        
        
        
        
        
        </>





    )







}


export default QuotationDollor